module.exports = "<span>&copy; {{settings.app.year}} - {{ settings.app.name }}</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/footer/footer.component.html
// module id = ./src/app/layout/footer/footer.component.html
// module chunks = main